import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-it-services',
  templateUrl: './it-services.component.html',
  styleUrls: ['./it-services.component.scss']
})
export class ItServicesComponent implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'IT Resource Augmentation & Specialist Technology Teams | DotBlack',
      description: 'Access experienced IT specialists for projects, flexible contracts and permanent placements across key technology disciplines.',
      path: '/it-services/',
      type: 'website',
      schema: { '@context': 'https://schema.org', '@type': 'Service', name: 'Specialist IT Teams', provider: { '@type': 'Organization', name: 'DotBlack Projex Pty (Ltd)', url: 'https://dotblack.co.za/' }, url: 'https://dotblack.co.za/it-services/' }
    });
  }
}
